import { Container, Skeleton } from "@mui/material";
import React, { useContext } from "react";
import CurrentUserContext from "../../../../contexts/CurrentUserContext";
import { FormRegisterObject } from "./FormRegisterObject";

export const RegisterObject = () => {
  const { isLoadingUser } = useContext(CurrentUserContext);

  return (
    <Container sx={{ padding: 4 }} maxWidth={"md"}>
      {isLoadingUser ? <SkeletonRegisterPet /> : <FormRegisterObject />}
    </Container>
  );
};

const SkeletonRegisterPet = () => {
  return (
    <>
      <Skeleton width="100%" height={50} />
      <Skeleton width="100%" height={100} />
      <Skeleton width="100%" height={100} />
      <Skeleton width="100%" height={100} />
    </>
  );
};
